export { getWebInstrumentations } from './getWebInstrumentations';

export { makeCoreConfig } from './makeCoreConfig';

export type { BrowserConfig, GetWebInstrumentationsOptions } from './types';
